var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.79623 2.7434C8.79623 2.33283 8.4634 2 8.05283 2C7.64227 2 7.30944 2.33283 7.30944 2.7434L7.30944 7.20377L2.7434 7.20377C2.33283 7.20377 2 7.5366 2 7.94717C2 8.35773 2.33283 8.69056 2.7434 8.69056H7.30944L7.30943 13.2566C7.30943 13.6672 7.64226 14 8.05283 14C8.4634 14 8.79623 13.6672 8.79623 13.2566L8.79623 8.69057H13.2566C13.6672 8.69057 14 8.35774 14 7.94717C14 7.5366 13.6672 7.20377 13.2566 7.20377L8.79623 7.20377L8.79623 2.7434Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.92e41c985d65ea4b0ac2203bf8b03342.svg";
export { ForwardRef as ReactComponent };